if(typeof _GIRL_CONF['pantress']['game_memory']=='undefined'){_GIRL_CONF['pantress']['game_memory']={};};
_GIRL_CONF['pantress']['game_memory']['face']={left:622,top:123,width:160,height:185};
_GIRL_CONF['pantress']['game_memory']['hair']={left:467,top:35,width:360,height:266};
_GIRL_CONF['pantress']['game_memory']['hand1']={left:435,top:312,width:382,height:296};
_GIRL_CONF['pantress']['game_memory']['hand2']={left:421,top:222,width:101,height:275};
_GIRL_CONF['pantress']['game_memory']['item1']={left:195,top:288,width:228,height:438};
_GIRL_CONF['pantress']['game_memory']['item2']={left:796,top:377,width:146,height:293};
_GIRL_CONF['pantress']['game_memory']['tit1']={left:577,top:350,width:142,height:108};
_GIRL_CONF['pantress']['game_memory']['tit2']={left:471,top:351,width:121,height:108};
